import { Repository } from "../../adapters/repository";
import { present } from "../../../utils/presenter";
import { Interactor } from "./types";

function createInteractor(repository: Repository): Interactor {
  return (group) =>
    present(
      repository
        .removeResourceGroup(group)
        .then(() => group)
        .catch(() => Promise.reject(group)),
    );
}

export type { Interactor };

export { createInteractor };
